export default __webpack_public_path__ + "static/media/icn-_blank-white.8efa4046.svg";